var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pdf",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13225",
    "data-name": "Path 13225",
    d: "M2.5,14.5V.5H9.9l3.6,3.7V14.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13226",
    "data-name": "Path 13226",
    d: "M9.7,1,13,4.4V14H3V1H9.7m.4-1H2V15H14V4L10.1,0Z",
    fill: "#c74343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13227",
    "data-name": "Path 13227",
    d: "M9.5,4.5V.5h.3l3.7,3.7v.3Z",
    fill: "#ffd9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13228",
    "data-name": "Path 13228",
    d: "M10,1.4,12.6,4H10V1.4M10,0H9V5h5V4L10,0ZM5.2,12.4a.773.773,0,0,1-.8-.7c0-.7.8-1.2,1.8-1.6a.1.1,0,0,1,.1-.1,12.782,12.782,0,0,0,.9-2.2,4.433,4.433,0,0,1-.3-1.5A1.483,1.483,0,0,1,7,5.6a.841.841,0,0,1,1.4,0,1.445,1.445,0,0,1,.2.7,6.134,6.134,0,0,1-.3,1.6,4.671,4.671,0,0,0,.5,1c.2.2.3.4.5.5a4.25,4.25,0,0,1,1.7.1.958.958,0,0,1,.7.8,1.421,1.421,0,0,1-.2.6,1.136,1.136,0,0,1-.8.3h0A2.465,2.465,0,0,1,9,10.4a12.86,12.86,0,0,0-1.9.4C6.4,11.8,5.8,12.4,5.2,12.4Zm5.5-2ZM7.8,9.1c-.1.2-.1.4-.2.6.2,0,.4-.1.6-.1A1.756,1.756,0,0,1,7.8,9.1Z",
    fill: "#c74343"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4e79b55aaaa8e2391683eb75f2dc0c04.svg";
export { ForwardRef as ReactComponent };